export default __webpack_public_path__ + "static/media/logoreg.2fef6535.svg";